const ClientCount = () => {
  return 'ClientCount';
};

export default ClientCount;
